import { useState, useEffect } from 'react';
import { RangeCalandar } from '../../common/Calandar';
import LogApi from '../../api/LogApi';
import LogList from './LogList';
    
const Logs = () => {
    const [dateRange, setDateRange] = useState('');
    const [counts, setCounts] = useState({
        total: 0,
        totalSlots: 0,
        totalDays: 0,
    });


    useEffect(() => {
        console.log(dateRange);
        LogApi.getLogCounts({ dateRange }).then(res => {
            console.log(res);
            setCounts(res.data);
        });
    }, [dateRange]);

    return (
        <div className="vh-content-wrap">
			<div className="content-header">
				<h1>로그관리</h1>
				<h2>슬롯의 발주 및 환불 로그를 확인할 수 있습니다.</h2>
			</div>
			<div className="content">
				<div className="board-area">
					<div className="board-row">
						<div className="filter-datetime">
                            <RangeCalandar onDateChange={setDateRange} />
						</div>
					</div>
					<div className="board-row">
						<a className="board-card">
							<div className="board-card-title">
								<strong>전체</strong>
								<span>전체 로그 개수</span>
							</div>
							<div className="board-card-p">{counts.total}개</div>
						</a>
						<a className="board-card">
							<div className="board-card-title">
								<strong>수량 합계</strong>
								<span>구동중인 슬롯 수량 합계</span>
							</div>
							<div className="board-card-p">{counts.totalSlots}개</div>
						</a>
                        <a className="board-card">
							<div className="board-card-title">
								<strong>일수 합계</strong>
								<span>구동중인 일수 합계</span>
							</div>
							<div className="board-card-p">{counts.totalDays}개</div>
						</a>
					</div>
				</div>

				<LogList total={counts.total} dateRange={dateRange} />
			</div>
		</div>
    )
}

export default Logs;